<template>
  <div class="index2-mobile-host">
    <Index2 />
  </div>
</template>

<script>
import Index2 from './index2.vue'

export default {
  name: 'Index2Mobile',
  components: { Index2 }
}
</script>

<style>
.index2-mobile-host {
  width: 100%;
  min-height: 100dvh;
  overflow-x: hidden;
}

@media (max-width: 768px) {
  .index2-mobile-host .ivu-poptip-popper,
  .index2-mobile-host .ivu-tooltip-popper {
    max-width: calc(100vw - 20px) !important;
  }

  .index2-mobile-host .ivu-poptip-body-content {
    max-height: 68dvh;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index2Mobile.vue